let html = `<div class="activity-wait-refresh">
    <div class="activity-wait-refresh__title">Ожидаю</div>
    <div class="activity-wait-refresh__text">Нажмите (вниз) для обновления активности.</div>

    <div class="activity-wait-refresh__items">
        <div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>`

export default html